import { useState } from 'react';
import { useGetUserById } from './use-get-user-by-id';
import { useUserRelatedSections } from './use-user-related-sections';

export const useUserWidget = (id: number | string) => {
  const [visible, setVisible] = useState(false);
  const { data, isLoading } = useGetUserById(id, { enabled: visible, staleTime: 1000 * 15 });
  const sections = useUserRelatedSections(id, data);

  return { visible, setVisible, data, isLoading, ...sections };
};
